import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import { Logger } from '@main/utils/logger';
import { publishEvent } from '@salesforce/scv-connector-base';
import type { PhoneCall } from '@salesforce/scv-connector-base';
import { Constants, SuperviseCallResult } from '@salesforce/scv-connector-base';
import type { SupervisorListenEventPublisher } from './supervisor-listening.usecase';

export class SupervisorListenPublisher
  implements SupervisorListenEventPublisher
{
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish(
    call: PhoneCall,
    callId: string,
    agentNumber: string,
  ): Promise<void> {
    const busIframe = await BusIframe.getIframe();
    const busEvent: BusEvent = {
      type: 'DIALER.JOIN_COACHING',
      payload: {
        callUuid: callId,
        incognito: true,
        agentNumber: agentNumber,
      },
    };

    this.logger.info('Publisher: Supervisor listen in', {
      action: 'supervisorListen',
      callId,
      agentNumber,
    });
    publishEvent({
      eventType: Constants.VOICE_EVENT_TYPE.SUPERVISOR_CALL_CONNECTED,
      payload: new SuperviseCallResult({ call: call }),
      registerLog: true,
    });

    return BusEventsPromisifier.promisifyFireAndForgetEvent({
      target: busIframe,
      event: busEvent,
    });
  }
}
